import { render, staticRenderFns } from "./courseware-exercise.vue?vue&type=template&id=774f5af7&scoped=true&"
import script from "./courseware-exercise.vue?vue&type=script&lang=js&"
export * from "./courseware-exercise.vue?vue&type=script&lang=js&"
import style0 from "./courseware-exercise.vue?vue&type=style&index=0&id=774f5af7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774f5af7",
  null
  
)

component.options.__file = "courseware-exercise.vue"
export default component.exports